import { render, staticRenderFns } from "./PolizaNegocio.vue?vue&type=template&id=0d7229ca&scoped=true&"
import script from "./PolizaNegocio.vue?vue&type=script&lang=js&"
export * from "./PolizaNegocio.vue?vue&type=script&lang=js&"
import style0 from "./PolizaNegocio.vue?vue&type=style&index=0&id=0d7229ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7229ca",
  null
  
)

export default component.exports